import { marketAsyncComponent } from '@/utils/asyncComponent';

export default marketAsyncComponent('vm-select-business', '0.0.4', { crossorigin: 'anonymous' });
